// @flow

import React from 'react'
import styled from 'styled-components'

const TextFieldInput = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #b3b3b3;
  border-radius: 3px;
  outline: 0;
  height: 32px;
  &::-webkit-input-placeholder {
    color: #d1d1d1;
    line-height: 1.286;
    padding-top: 2px;
  }
  @include mq-max(sm) {
    height: 40px;
    padding: 12px;
  }
`

function getTextFieldTypeClassName(textFieldType: string) {
  switch (textFieldType) {
    case 'calendar':
      return 'search-side__form-small-calendar'
    default:
      return ''
  }
}

export default ({
  label,
  iconType,
  readOnly,
  onChange,
  onClick,
  value,
  inputRef,
  textFieldType,
}) => (
  <div className="search-side__item-select">
    <div
      className={`search-side__form-small ${getTextFieldTypeClassName(
        textFieldType,
      )}`}
    >
      <TextFieldInput
        type="text"
        placeholder={label}
        onChange={onChange}
        onClick={onClick}
        readOnly={readOnly}
        value={value}
        innerRef={inputRef}
      />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/molecules/SearchTextField.jsx